<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="dataTable"
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="DailyReport"
      icon="mdi-cards"
    >
      <template #primaryButton>
        <v-btn
          class="mr-2"
          color="amber lighten-4 black--text"
          dark
          elevation="0"
          @click="exportCSV()"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('export') }}
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import dailyReprot from '@/model/dataLayer/api/statistic/dailyReprot'
import FileSaver from 'file-saver'
import i18n from '@/i18n'

export default {
  name: 'DailyStatistics',
  components: {
    IkDataTable
  },
  data () {
    return {
      model: dailyReprot
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async exportCSV () {
      const data = this.$refs.dataTable.items
      let dataStrings = [[i18n.t('startTime'), i18n.t('endTime'), i18n.t('orderCount'), i18n.t('Customers'), i18n.t('sumTotal'), i18n.t('sumTipIncome'), i18n.t('tax')].join(',')]
      data.forEach(it => {
        const res = [it.startsAt, it.endsAt, it.DOCount, it.totalPersonCount, it.sumTotalPrice, it.sumTipIncome, it.taxInfo.replaceAll(',', '.')]
        dataStrings.push(res.join())
      })
      dataStrings = dataStrings.join('\n')
      const blob = new Blob([dataStrings], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(blob, 'Daily Statistics.csv')
    }
  }
}
</script>

<style scoped>

</style>
